<template>
	<transition 
			appear
			:appear-active-class="$_tabLyt_stylePageLayoutAnimation()">
		<v-row no-gutters>
			<v-col>
				<!-- tab for mobile (dropdown) -->
				<template v-if="$_tabLyt_stateAppIsMobileScreen">
					<v-row no-gutters>
						<v-col>
							<v-toolbar color="transparent">
								<v-menu offset-y>
									<template v-slot:activator="{ on }">
										<v-btn	class="customVBtn"
												color="primary"
												icon
												dark
												v-on="on">
											<v-icon>
												keyboard_arrow_down
											</v-icon>
										</v-btn>
									</template>
									<v-list>
										<template v-for="(contentVals, contentKey, contentIndex) in sortObject(contents, 'order')">
											<template v-if="checkMenuGroup(contentVals.menuGroup, true) && checkSecurityGroup(contentVals.securityGroup, true)">
												<v-list-item
														:key="contentKey"
														@click="$_tabLyt_select(contentVals, contentIndex)">
													<v-list-item-title
															v-html="$_tabLyt_langContentTabTitle(contentVals)" />
												</v-list-item>
											</template>
										</template>
									</v-list>
								</v-menu>
								<v-toolbar-title 
										v-html="tabTitle_" />
							</v-toolbar>
						</v-col>
					</v-row>
				</template>
				<v-row no-gutters>
					<!-- tab for web (vertical) -->
					<template v-if="!$_tabLyt_stateAppIsMobileScreen">
						<v-col cols="auto">
							<v-tabs v-model="tabNumber_"
							
									class="customVTabs"
									vertical

									:background-color="$_tabLyt_styleTabsBackgroundColor"
									:color="$_tabLyt_styleTabsColor"
									:dark="$_tabLyt_styleTabsDark"
									:hide-slider="$_tabLyt_styleTabsHideSlider"
									:light="$_tabLyt_styleTabsLight"
									:slider-color="$_tabLyt_styleTabsSliderColor">
								<template v-for="(contentVals, contentKey) in sortObject(contents, 'order')">
									<template v-if="checkMenuGroup(contentVals.menuGroup, true) && checkSecurityGroup(contentVals.securityGroup, true)">
										<v-tab	:key="contentKey"
												class="caption"

												:dark="$_tabLyt_styleTabDark"
												:light="$_tabLyt_styleTabLight"

												v-html="$_tabLyt_langContentTabTitle(contentVals)" />
									</template>
								</template>
							</v-tabs>
						</v-col>
					</template>
					<v-spacer />
					<!-- tab content -->
					<v-col cols="11" md="8">
						<v-tabs-items
								class="customVTabs"
								v-model="tabNumber_">
							<template v-for="(contentVals, contentKey) in sortObject(contents, 'order')">
								<template v-if="checkMenuGroup(contentVals.menuGroup, true) && checkSecurityGroup(contentVals.securityGroup, true)">
									<v-tab-item :key="contentKey">
										<v-row class="customVRow" no-gutters>
											<v-col>
												<template v-if="contentVals.title">
													<v-row justify="center">
														<v-col>
															<v-sheet
																	class="customVSheet pa-3"
																	:color="$_tabLyt_styleHeaderSheetColor"
																	:dark="$_tabLyt_styleHeaderSheetDark"
																	:elevation="$_tabLyt_styleHeaderSheetElevation"
																	:light="$_tabLyt_styleHeaderSheetLight">
																<v-card color="transparent" flat>
																	<v-card-text class="center">
																		<center>
																			<span	class="headline"
																					v-html="$_tabLyt_langContentTitle(contentVals)" />
																		</center>
																	</v-card-text>
																</v-card>
															</v-sheet>
														</v-col>
													</v-row>
												</template>
												<v-row>
													<v-col>
														<v-sheet
																class="customVSheet"
																:color="$_tabLyt_styleBodySheetColor"
																:dark="$_tabLyt_styleBodySheetDark"
																:elevation="$_tabLyt_styleBodySheetElevation"
																:light="$_tabLyt_styleBodySheetLight">
															<v-card	class="customVCard"
																	color="transparent"
																	flat>
																<template v-if="contentVals.bigImage">
																	<v-row>
																		<v-col>
																			<v-img	class="customVImg"
																					:src="$_tabLyt_styleContentBigImageUrl(contentVals)" />
																		</v-col>
																	</v-row>
																</template>
																<template v-if="!isEmpty(contentVals.video)">
																	<v-row>
																		<v-col>
																			<card-video
																					:contentKey="contentKey"
																					:contents="contents"
																					:inits="inits" />
																		</v-col>
																	</v-row>
																</template>
																<v-row>
																	<template v-if="isObject(contentVals.image)">
																		<v-col cols="12" md="4" class="center">
																			<v-img	class="customVImg"
																					:src="$_tabLyt_styleContentImageUrl(contentVals)" />
																		</v-col>
																	</template>
																	<template v-if="contentVals.subTitle || contentVals.text || contentVals.actionButtons">
																		<v-col>
																			<template v-if="contentVals.subTitle">
																				<v-row no-gutters>
																					<v-col>
																						<v-card-title>
																							<span v-html="$_tabLyt_langContentSubTitle(contentVals)" />
																						</v-card-title>
																					</v-col>
																				</v-row>
																			</template>
																			<template v-if="contentVals.text">
																				<v-row no-gutters>
																					<v-col>
																						<v-card-text>
																							<span v-html="$_tabLyt_langContentText(contentVals)" />
																						</v-card-text>
																					</v-col>
																				</v-row>
																			</template>
																			<template v-if="contentVals.actionButtons">
																				<v-row no-gutters>
																					<v-col>
																						<v-card-actions>
																							<v-row>
																								<template v-for="(actionButtonVals, actionButtonKey) in sortObject(contentVals.actionButtons, 'order')">
																									<v-col :key="actionButtonKey" cols="auto">
																										<v-btn	class="customVBtn"
																												:block="$_tabLyt_styleActionButtonBlock"
																												:color="$_tabLyt_styleActionButtonColor"
																												:dark="$_tabLyt_styleActionButtonDark"
																												:depressed="$_tabLyt_styleActionButtonDepressed"
																												:elevation="$_tabLyt_styleActionButtonElevation"
																												:large="$_tabLyt_styleActionButtonLarge"
																												:light="$_tabLyt_styleActionButtonLight"
																												:outlined="$_tabLyt_styleActionButtonOutlined"
																												:rounded="$_tabLyt_styleActionButtonRounded"
																												:small="$_tabLyt_styleActionButtonSmall"
																												:text="$_tabLyt_styleActionButtonFlat"
																												@click="openLink(actionButtonVals.link)"
																												v-text="$_tabLyt_langActionButtonTitle(actionButtonVals)" />
																									</v-col>
																								</template>
																							</v-row>
																						</v-card-actions>
																					</v-col>
																				</v-row>
																			</template>
																		</v-col>
																	</template>
																</v-row>
															</v-card>
														</v-sheet>
													</v-col>
												</v-row>
											</v-col>
										</v-row>
									</v-tab-item>
								</template>
							</template>
						</v-tabs-items>
					</v-col>
					<v-spacer />
				</v-row>
			</v-col>
		</v-row>
	</transition>
</template>

<script>
	export default {
		name: 'TabLayout',
		props: {
			contents: Object,
			inits: Object
		},
		data() {
			return {
				tabNumber_: 0,
				tabTitle_: null,
				
				colors_: {}
			}
		},
		computed: {
			// state
			$_tabLyt_stateAppIsMobileScreen() {
				const self_ = this;
				return self_.getAppState('isMobileScreen')
			},
			// lang 
			// (content)
			$_tabLyt_langContentTabTitle() {
				const self_ = this;
				return contentVals => {
					const contentVal_ = contentVals.tabTitle;
					if(self_.isFalse(contentVal_)) { return null }
					return self_.getLangsVal(contentVal_)
				}
			},
			$_tabLyt_langContentTitle() {
				const self_ = this;
				return contentVals => {
					const contentVal_ = contentVals.title;
					if(self_.isFalse(contentVal_)) { return null }
					return self_.getLangsVal(contentVal_)
				}
			},
			$_tabLyt_langContentSubTitle() {
				const self_ = this;
				return contentVals => {
					const contentVal_ = contentVals.subTitle;
					if(self_.isFalse(contentVal_)) { return null }
					return self_.getLangsVal(contentVal_)
				}
			},
			$_tabLyt_langContentText() {
				const self_ = this;
				return contentVals => {
					const contentVal_ = contentVals.text;
					if(self_.isFalse(contentVal_)) { return null }
					return self_.getLangsVal(contentVal_)
				}
			},
			// (content - action button)
			$_tabLyt_langActionButtonTitle() {
				const self_ = this;
				return actionButtonVals => {
					const actionButtonVal_ = actionButtonVals.title;
					if(self_.isFalse(actionButtonVal_)) { return null }
					return self_.getLangsVal(actionButtonVal_)
				}
			},
			// style
			$_tabLyt_stylePageLayout() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.inits)) { return null }
					return self_.getInitsStyleVal(self_.inits, 'pageLayout')
				}
			},
			$_tabLyt_stylePageLayoutAnimation() {
				const self_ = this;
				return () => {
					const layout_ = self_.$_tabLyt_stylePageLayout()
					if(self_.isFalse(layout_)) { return null }
					return self_.getStylesVal(layout_.animation)
				}
			},
			$_tabLyt_styleTabs() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'tabs')
			},
			$_tabLyt_styleTabsBackgroundColor() {
				const self_ = this;
				const tabs_ = self_.$_tabLyt_styleTabs;
				if(self_.isFalse(tabs_)) { return null }
				return self_.getStylesVal(tabs_.backgroundColor)
			},
			$_tabLyt_styleTabsColor() {
				const self_ = this;
				const tabs_ = self_.$_tabLyt_styleTabs;
				if(self_.isFalse(tabs_)) { return null }
				return self_.getStylesVal(tabs_.color)
			},
			$_tabLyt_styleTabsDark() {
				const self_ = this;
				const tabs_ = self_.$_tabLyt_styleTabs;
				if(self_.isFalse(tabs_)) { return null }
				return self_.getStylesVal(tabs_.dark)
			},
			$_tabLyt_styleTabsHideSlider() {
				const self_ = this;
				const tabs_ = self_.$_tabLyt_styleTabs;
				if(self_.isFalse(tabs_)) { return null }
				return self_.getStylesVal(tabs_.hideSlider)
			},
			$_tabLyt_styleTabsLight() {
				const self_ = this;
				const tabs_ = self_.$_tabLyt_styleTabs;
				if(self_.isFalse(tabs_)) { return null }
				return self_.getStylesVal(tabs_.light)
			},
			$_tabLyt_styleTabsSliderColor() {
				const self_ = this;
				const tabs_ = self_.$_tabLyt_styleTabs;
				if(self_.isFalse(tabs_)) { return null }
				return self_.getStylesVal(tabs_.sliderColor)
			},
			$_tabLyt_styleTab() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'tab')
			},
			$_tabLyt_styleTabDark() {
				const self_ = this;
				const tab_ = self_.$_tabLyt_styleTab;
				if(self_.isFalse(tab_)) { return null }
				return self_.getStylesVal(tab_.dark)
			},
			$_tabLyt_styleTabLight() {
				const self_ = this;
				const tab_ = self_.$_tabLyt_styleTab;
				if(self_.isFalse(tab_)) { return null }
				return self_.getStylesVal(tab_.light)
			},
			$_tabLyt_styleHeaderSheet() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'headerSheet')
			},
			$_tabLyt_styleHeaderSheetColor() {
				const self_ = this;
				const headerSheet_ = self_.$_tabLyt_styleHeaderSheet;
				if(self_.isFalse(headerSheet_)) { return null }
				return self_.getStylesVal(headerSheet_.color)
			},
			$_tabLyt_styleHeaderSheetDark() {
				const self_ = this;
				const headerSheet_ = self_.$_tabLyt_styleHeaderSheet;
				if(self_.isFalse(headerSheet_)) { return null }
				return self_.getStylesVal(headerSheet_.dark)
			},
			$_tabLyt_styleHeaderSheetElevation() {
				const self_ = this;
				const headerSheet_ = self_.$_tabLyt_styleHeaderSheet;
				if(self_.isFalse(headerSheet_)) { return null }
				return self_.getStylesVal(headerSheet_.elevation)
			},
			$_tabLyt_styleHeaderSheetLight() {
				const self_ = this;
				const headerSheet_ = self_.$_tabLyt_styleHeaderSheet;
				if(self_.isFalse(headerSheet_)) { return null }
				return self_.getStylesVal(headerSheet_.dark)
			},
			$_tabLyt_styleBodySheet() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'bodySheet')
			},
			$_tabLyt_styleBodySheetColor() {
				const self_ = this;
				const bodySheet_ = self_.$_tabLyt_styleBodySheet;
				if(self_.isFalse(bodySheet_)) { return null }
				return self_.getStylesVal(bodySheet_.color)
			},
			$_tabLyt_styleBodySheetDark() {
				const self_ = this;
				const bodySheet_ = self_.$_tabLyt_styleBodySheet;
				if(self_.isFalse(bodySheet_)) { return null }
				return self_.getStylesVal(bodySheet_.dark)
			},
			$_tabLyt_styleBodySheetElevation() {
				const self_ = this;
				const bodySheet_ = self_.$_tabLyt_styleBodySheet;
				if(self_.isFalse(bodySheet_)) { return null }
				return self_.getStylesVal(bodySheet_.elevation)
			},
			$_tabLyt_styleBodySheetLight() {
				const self_ = this;
				const bodySheet_ = self_.$_tabLyt_styleBodySheet;
				if(self_.isFalse(bodySheet_)) { return null }
				return self_.getStylesVal(bodySheet_.light)
			},
			$_tabLyt_styleActionButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'actionButton')
			},
			$_tabLyt_styleActionButtonBlock() {
				const self_ = this;
				const actionButton_ = self_.$_tabLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.block)
			},
			$_tabLyt_styleActionButtonColor() {
				const self_ = this;
				const actionButton_ =self_.$_tabLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.color)
			},
			$_tabLyt_styleActionButtonDark() {
				const self_ = this;
				const actionButton_ = self_.$_tabLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.dark)
			},
			$_tabLyt_styleActionButtonDepressed() {
				const self_ = this;
				const actionButton_ = self_.$_tabLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.depressed)
			},
			$_tabLyt_styleActionButtonElevation() {
				const self_ = this;
				const actionButton_ = self_.$_tabLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.elevation)
			},
			$_tabLyt_styleActionButtonFlat() {
				const self_ = this;
				const actionButton_ = self_.$_tabLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.flat)
			},
			$_tabLyt_styleActionButtonLarge() {
				const self_ = this;
				const actionButton_ = self_.$_tabLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.large)
			},
			$_tabLyt_styleActionButtonLight() {
				const self_ = this;
				const actionButton_ = self_.$_tabLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.light)
			},
			$_tabLyt_styleActionButtonOutlined() {
				const self_ = this;
				const actionButton_ = self_.$_tabLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.outlined)
			},
			$_tabLyt_styleActionButtonRounded() {
				const self_ = this;
				const actionButton_ = self_.$_tabLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.rounded)
			},
			$_tabLyt_styleActionButtonSmall() {
				const self_ = this;
				const actionButton_ = self_.$_tabLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.small)
			},
			// (content)
			$_tabLyt_styleContentBigImage() {
				return contentVals => {
					return contentVals.image
				}
			},
			$_tabLyt_styleContentBigImageUrl() {
				const self_ = this;
				return contentVals => {
					const image_ = self_.$_tabLyt_styleContentBigImage(contentVals);
					if(self_.isEmpty(image_)) { return null }
					return self_.getStylesVal(image_.url)
				}
			},
			$_tabLyt_styleContentImage() {
				return contentVals => {
					return contentVals.image
				}
			},
			$_tabLyt_styleContentImageUrl() {
				const self_ = this;
				return contentVals => {
					const image_ = self_.$_tabLyt_styleContentImage(contentVals);
					if(self_.isEmpty(image_)) { return null }
					return self_.getStylesVal(image_.url)
				}
			}
		},
		methods: {
			$_tabLyt_getChanceColor(key) {
				const self_ = this;

				if(self_.colors_[key]) { return self_.colors_[key] }

				self_.colors_[key] = self_.getChanceColor();
				return self_.colors_[key]
			},
			$_tabLyt_select(contentVals, contentIndex) {
				const self_ = this;

				self_.tabNumber_ = contentIndex;
				self_.tabTitle_ = self_.$_tabLyt_langContentTabTitle(contentVals);
			}
		}
	}
</script>

<style scoped>
</style>
